import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { SearchResult } from '~/types/fulltextSearch';

export const useFulltextSearchStore = defineStore('fulltextSearchStore', () => {
  const searchQuery = ref('');
  const showSearchResults = ref(false);
  const searchResults = ref<SearchResult[]>([]);
  const isLoading = ref(false);
  const isOverlayVisible = ref(false);

  const clearSearch = () => {
    showSearchResults.value = false;
    searchResults.value = [];
  };

  const hideOverlay = () => {
    isOverlayVisible.value = false;
    clearSearch();
  };

  const hideResults = (force: boolean = false) => {
    showSearchResults.value = false;
    searchResults.value = [];
    if (force) searchQuery.value = '';
  };

  const toggleOverlay = () => {
    isOverlayVisible.value = !isOverlayVisible.value;
    if (!isOverlayVisible.value) clearSearch();
  };

  return {
    searchQuery,
    searchResults,
    isLoading,
    isOverlayVisible,
    showSearchResults,
    clearSearch,
    hideOverlay,
    hideResults,
    toggleOverlay
  };
});
